/*
 * @Author: your name
 * @Date: 2020-07-23 16:20:22
 * @LastEditTime: 2020-10-09 10:20:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-h5-workspace/packages/xdap-h5/src/router/index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home.vue'
import Blank from '@/pages/blank/blank.vue'
import Error from '@/pages/error/error.vue'
import Workbench from '@/pages/workbench/workbench.vue'
import HomePage from '@/pages/home-page/home-page.vue'
import AppEngineList from '@/pages/app-engine/app-engine-list/app-engine-list.vue'
import AppEngineForm from '@/pages/app-engine/app-engine-form/app-engine-form.vue'
import AppEngineAnalyse from '@/pages/app-engine/app-engine-analyse/app-engine-analyse.vue'
import AppEngineMenu from '@/pages/app-engine/app-engine-menu/app-engine-menu'
import Test from '@/pages/test/test.vue'
import DreamfishTest from '@/pages/dreamfish-test/dreamfish-test'
import AccountRoutes from './account'
import FormRoutes from './form'
import AppMessage from '@/pages/message-center/app-message/app-message.vue'
import PublicForm from '@/pages/blank/public-form/public-form'
import PublicFormContent from '@/pages/blank/public-form/form-content/form-content'
import PublicSubmitSuccess from '@/pages/blank/public-form/submit-success/submit-success'
import ErrorPage from '@/pages/error/error-page/error-page.vue'
import Error416 from '@/pages/error/error-416/error-416.vue'
import Error417 from '@/pages/error/error-417/error-417.vue'
import Error424 from '@/pages/error/error-424/error-424.vue'
import EmptyOrg from '@/pages/error/empty-org/empty-org'
import PersonalCenter from '@/pages/personal-center/personal-center.vue'
import HelpFeedback from '@/pages/personal-center/help-feedback/help-feedback.vue'
import SwitchTenant from '@/pages/personal-center/switch-tenant/switch-tenant.vue'
import ProfileDetail from '@/pages/personal-center/profile-detail/profile-detail.vue'
import InputProfile from '@/pages/personal-center/input-profile/input-profile.vue'
import Setting from '@/pages/personal-center/setting/setting.vue'
import TodoCenter from '@/pages/todo-center/todo-center.vue'
import MultiLineProfile from '@/pages/personal-center/input-profile/multi-line-profile.vue'
import MessageCenter from '@/pages/message-center/message-center.vue'
import AppAssociatedForm from '@/pages/app-engine/app-associated-form/app-associated-form.vue'
import AppAssociatedList from '@/pages/app-engine/app-associated-list/app-associated-list.vue'
import MyTodo from '@/pages/todo-center/my-todolist.vue'
import MySubmit from '@/pages/todo-center/my-submit.vue'
import MyDone from '@/pages/todo-center/my-done.vue'
import About from '@/pages/personal-center/about/about.vue'
import ServiceProtocol from '@/pages/personal-center/about/service-protocol.vue'
import ThirdAccount from '@/pages/personal-center/third-account/third-account.vue'
import OrgSetting from '@/pages/account/org-setting/org-setting'
import OrgCreate from '@/pages/account/org-setting/create-org/create-org'
import OrgJoin from '@/pages/account/org-setting/join-org/join-org'
import WaitingApproval from '@/pages/blank/waiting-approval/waiting-approval'
// 评论
import RecordComment from '@/pages/app-engine/record-comment'
Vue.use(VueRouter)

const routes = [
  {
    path: '/'
  },
  {
    path: '/index.html'
  },
  {
    path: '/test',
    name: 'test',
    component: Test,
    children: []
  },
  {
    path: '/dreamfish-test',
    name: 'dreamfish-test',
    component: DreamfishTest
  },
  {
    path: '/testP',
    name: 'testP',
    component: PersonalCenter,
    children: []
  },
  {
    path: '/help-feedback',
    name: 'help-feedback',
    component: HelpFeedback,
    meta: {
      title: '帮助与反馈'
    }
  },
  {
    path: '/switch-tenant',
    name: 'switch-tenant',
    component: SwitchTenant,
    meta: {
      title: '切换组织'
    }
  },
  {
    path: '/profile-detail',
    name: 'profile-detail',
    component: ProfileDetail,
    meta: {
      title: '个人资料'
    }
  },
  {
    path: '/edit-profile',
    name: 'edit-profile',
    component: InputProfile
  },
  {
    path: '/setting',
    name: 'setting',
    component: Setting,
    meta: {
      title: '设置'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      title: '关于得帆云'
    }
  },
  {
    path: '/service-protocol',
    name: 'service-protocol',
    component: ServiceProtocol,
    meta: {
      title: '用户服务协议'
    }
  },
  {
    path: '/third-account',
    name: 'third-account',
    component: ThirdAccount,
    meta: {
      title: '第三方账号'
    }
  },
  {
    path: '/multi-line-profile',
    name: 'multi-line-profile',
    component: MultiLineProfile
  },
  {
    path: '/blank',
    name: 'blank',
    component: Blank,
    children: [
      {
        path: 'public-form',
        name: 'publicForm',
        component: PublicForm,
        redirect: {
          name: 'publicFormContent'
        },
        children: [
          {
            path: 'form-content',
            name: 'publicFormContent',
            component: PublicFormContent
          },
          {
            path: 'submit-success',
            name: 'publicSubmitSuccess',
            component: PublicSubmitSuccess
          }
        ]
      },
      {
        path: 'waiting-approval',
        name: 'waiting-approval',
        component: WaitingApproval,
        meta: {
          title: '得帆云',
          header: true
        }
      }
    ]
  },
  {
    path: '/error',
    name: 'error',
    component: Error,
    redirect: { name: '423' },
    children: [
      {
        path: '423',
        name: '423',
        component: ErrorPage
      },
      {
        path: '416',
        name: '416',
        component: Error416
      },
      {
        path: '417',
        name: '417',
        component: Error417
      },
      {
        path: '424',
        name: '424',
        component: Error424
      },
      {
        path: 'empty-org',
        name: 'emptyOrg',
        component: EmptyOrg
      }
    ]
  },
  { ...AccountRoutes },
  {
    path: '/:orgId/home',
    name: 'home',
    component: Home,
    children: [
      {
        path: 'list',
        name: 'appList',
        component: AppEngineList
      },
      {
        path: 'menu',
        name: 'appMenu',
        component: AppEngineMenu
      },
      {
        path: 'form',
        name: 'form',
        component: AppEngineForm
      },
      {
        path: 'analyse',
        name: 'appAnalyse',
        component: AppEngineAnalyse
      },
      {
        path: ':formId/associated-form',
        name: 'associated-form',
        component: AppAssociatedForm,
        meta: {
          title: '数据详情'
        }
      },
      {
        path: 'associated-list',
        name: 'associated-list',
        component: AppAssociatedList,
        meta: {
          title: '数据列表'
        }
      },
      {
        path: 'record-comment',
        name: 'RecordComment',
        component: RecordComment,
        meta: {
          title: '评论'
        }
      },
      { ...FormRoutes }
    ]
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    children: [
      {
        path: 'app-message',
        name: 'app-message',
        component: AppMessage
      }
    ]
  },
  {
    path: '/home-page',
    name: 'home-page',
    component: HomePage,
    redirect: { name: 'workbench' },
    children: [
      {
        path: ':orgId/workbench',
        name: 'workbench',
        component: Workbench,
        meta: {
          header: true,
          keepAlive: true
        }
      },
      {
        path: ':orgId/todo-center',
        name: 'todo-center',
        component: TodoCenter,
        meta: {
          title: '待办',
          header: true,
          keepAlive: true
        },
        children: [
          {
            path: 'my-todo',
            name: 'my-todo',
            component: MyTodo,
            meta: {
              keepAlive: true
            }
          },
          {
            path: 'my-submit',
            name: 'my-submit',
            component: MySubmit,
            meta: {
              keepAlive: true
            }
          },
          {
            path: 'my-participate',
            name: 'my-participate',
            component: MyDone,
            meta: {
              keepAlive: true
            }
          }
        ]
      },
      {
        path: 'message-center',
        name: 'message-center',
        component: MessageCenter,
        meta: {
          title: '消息',
          header: true,
          keepAlive: true
        }
      },
      // {
      //   path: 'app-message',
      //   name: 'app-message',
      //   component: AppMessage
      // },
      {
        path: ':orgId/personal-center',
        name: 'personal-center',
        component: PersonalCenter,
        meta: {
          title: '我的',
          header: true,
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/org-setting',
    name: 'org-setting',
    component: OrgSetting,
    meta: {
      title: '得帆云',
      header: true
    }
  },
  {
    path: '/org-create',
    name: 'org-create',
    component: OrgCreate,
    meta: {
      title: '创建组织',
      header: true
    }
  },
  {
    path: '/org-join',
    name: 'org-join',
    component: OrgJoin,
    meta: {
      title: '加入组织',
      header: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes
})

export default router
